import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { teamsAPI } from '../services/api';
import './Teams.css';

interface Team {
  id: string;
  name: string;
  division?: string;
  ageGroup?: string;
  wins: number;
  losses: number;
  draws: number;
  players?: any[];
}

const Teams: React.FC = () => {
  const [teams, setTeams] = useState<Team[]>([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    loadTeams();
  }, []);

  const loadTeams = async () => {
    try {
      setLoading(true);
      const response = await teamsAPI.getStandings();
      setTeams(response.data);
    } catch (error) {
      console.error('Failed to load teams:', error);
    } finally {
      setLoading(false);
    }
  };

  const calculateWinPercentage = (team: Team) => {
    const total = team.wins + team.losses + team.draws;
    if (total === 0) return 0;
    return ((team.wins + team.draws * 0.5) / total * 100).toFixed(1);
  };

  const handleTeamClick = (teamId: string) => {
    navigate(`/players?team=${teamId}`);
  };

  if (loading) {
    return <div className="loading">Loading teams...</div>;
  }

  return (
    <div className="teams-page">
      <div className="hero-section">
        <h1>Our Teams</h1>
        <p>Team standings and information - Click on a team to view its players</p>
      </div>

      <div className="teams-container">
        <div className="teams-header">
          <h2>Team Standings</h2>
        </div>

        <div className="teams-table">
          <table>
            <thead>
              <tr>
                <th>Position</th>
                <th>Team</th>
                <th>Division</th>
                <th>Age Group</th>
                <th>W</th>
                <th>L</th>
                <th>D</th>
                <th>Win %</th>
              </tr>
            </thead>
            <tbody>
              {teams.map((team, index) => (
                <tr 
                  key={team.id} 
                  onClick={() => handleTeamClick(team.id)}
                  className="clickable-row"
                >
                  <td className="position-cell">{index + 1}</td>
                  <td className="team-cell"><strong>{team.name}</strong></td>
                  <td>{team.division || '-'}</td>
                  <td>{team.ageGroup || '-'}</td>
                  <td className="wins">{team.wins}</td>
                  <td className="losses">{team.losses}</td>
                  <td className="draws">{team.draws}</td>
                  <td><strong>{calculateWinPercentage(team)}%</strong></td>
                </tr>
              ))}
            </tbody>
          </table>

          {teams.length === 0 && (
            <div className="no-data">No teams available</div>
          )}
        </div>
      </div>
    </div>
  );
};

export default Teams;
